import styled, { css } from 'styled-components'

interface GoogleButtonProps {
  isMenu?: boolean
}

export const GoogleButton = styled.button<GoogleButtonProps>`
  border: ${(props) => (props.isMenu ? '1px solid #ff6600' : 'none')} !important;
  background: transparent;
  color: ${(props) => (props.isMenu ? '#ff6600' : '#4a4a4a')};
  border-radius: 5px;
  padding: 0.5rem 1.8rem;

  ${(props) =>
    !props.isMenu &&
    css`
      box-shadow: 0px 4px 8px rgba(94, 104, 113, 0.5);
    `}

  margin: 2rem 0 0.8rem;
  min-width: 270px !important;
  max-width: 270px !important;

  // width: 100%;

  display: flex;
  align-items: center;

  p {
    padding: 0;
    margin: 0 0 0 0.5rem;
    font-weight: 600;
    line-height: 1.3125rem;
  }
`
